import axiosInstance from "./axiosInstance";
export interface PropertyTypeApi {
  id: number;
  publicId: string;
  name: string;
  code: string;
  isActive: boolean;
  createdAt: string;
}
export interface PropertyTypeListResponse {
  items: PropertyTypeApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface CreatePropertyTypePayload {
  name: string;
  code: string;
  isActive: boolean;
  createdBy: string;
}
export interface UpdatePropertyTypePayload {
  publicId: string;
  name: string;
  code: string;
  isActive: boolean;
  updatedBy: string;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};


export const getPropertyTypes = async (params: {
  searchText?: string | null;
  pageNo: number;
  pageSize: number;
}):Promise<PropertyTypeListResponse> => {
  const res = await axiosInstance.get("/property-types/list", {
    headers: getAuthHeader(),
    params,
  });

  return res.data;
};

export const createPropertyType = async (
  payload: CreatePropertyTypePayload
) => {
  const res = await axiosInstance.post("/property-types", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const updatePropertyType = async (
  payload: UpdatePropertyTypePayload
) => {
  const res = await axiosInstance.put("/property-types", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const deletePropertyType = async (
  publicId: string,
  deletedBy: string
) => {
  const res = await axiosInstance.delete(
    `/property-types/${publicId}?deletedBy=${deletedBy}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};